import { h } from 'preact';
import * as BaseComp from 'components/bolt/toutVertical/toutVertical.js';
import s from 'components/bolt/toutVertical/toutVertical.sss';
import HTML from 'components/core/html/html';
import { Filters } from 'helpers/svgs';
import Close from 'components/bolt/icons/close';
import { accessNested, joinClasses, sortObjectByOrder } from 'utils/utils';
import parseQueryString from 'utils/parseQueryString';
import 'store/library';
import Store from 'store/store';
import { isVideosPage } from 'utils/bolt';
import slugify from 'utils/slugify';
import { getCopy } from 'utils/copy';
import { observeScroll, unobserveScroll } from 'utils/scrollObserver';
import { getDynamicData } from 'utils/bolt/dynamicData';
import { navigateInternally } from 'utils/bolt/index';

import HubTextOverlay from 'components/bolt/hub/components/hubTextOverlay/hubTextOverlay';

const NUM_STICKY_FILTER_CATEGORIES = 1;

export default class ToutVertical extends BaseComp.default {
	constructor(props) {
		super(props);
		this.titleRefs = {};
		this.setTitleRef = (key) => (el) => {
			this.titleRefs[key] = el;
		};

		const touts = Object.values(props.data?.Library?.touts || {});
		const toutFiltersAssigned = touts.reduce((acc, tout) => {
			if (tout.filters) {
				const filters = tout.filters.split(',').filter(e => e).map(item => item.trim());
				filters.forEach((filter) => {
					if (!acc.includes(filter)) acc.push(filter);
				});
			}
			return acc;
		}, []);
		// console.log('toutFiltersAssigned:', toutFiltersAssigned);
		// const filterCategories = sortObjectByOrder(this.pageData.filterCategories).filter((item) => item.filters);
		this.filterCategories = this.dynamicFilterCats?.length
			? this.dynamicFilterCats.map(cat => ({
				name: cat.category,
				filters: cat.filters.split(',').map(f => f.trim())
			}))
			: sortObjectByOrder(this.pageData.filterCategories)
				.filter(cat => cat.filters)
				.map(cat => ({
					name: cat.name,
					filters: cat.filters.split(',').map(f => f.trim())
				}));

		this.toggleFiltersMenu = this.toggleFiltersMenu.bind(this);
		this.onClearAllFilters = this.onClearAllFilters.bind(this);
		this.state = {
			...this.state,
			filtersMenuOpen: false,
			isTitleMultilineMap: {},
			libraryToutLength: 20
		};

		this.isbelowTheLineProduction = this.props.id === 'belowTheLineProduction';
		this.isEventsLibrary = this.props.id === 'events';
		this.isLibrary = this.isbelowTheLineProduction || this.isEventsLibrary;
		this.textOverlay = 'test';
	}

	async componentDidMount() {
		super.componentDidMount();

		if (this.props.appData?.options?.cmsManaged) {
			await this.loadCustomData();
		}

		if (this.isLibrary) {
			const touts = document.querySelectorAll(`.${s.tout}`);
			// console.log('Touts to observe:', touts.length);
			touts.forEach(tout => observeScroll(tout, { once: true }));

			const filtersContainer = document.querySelector(`.${s.filtersContainer}`);
			if (filtersContainer) {
				observeScroll(filtersContainer, { once: true });
			}
		} else {
			observeScroll(this.base, { once: true });
		}


		this.checkTitleHeight();
		Store.emit('SET_UP_VERTICAL_TOUT_FILTERS', ({
			pageId: this.props.id,
			filterCategories: this.filterCategories,
			ALL: this.props?.appData?.copy?.baseCopy?.$FILTERS_ALL
		}));
		const query = parseQueryString();
		if (query?.filter) {
			const filterCatIndex = this.filterCategories.findIndex(cat => cat.filters.includes(query.filter));
			if (filterCatIndex > -1) {
				this.onFilterBtnClick({ catIndex: filterCatIndex, filter: query.filter, isActive: false });
			}
		}
	}

	componentWillUnmount() {
		super.componentWillUnmount?.();

		const touts = document.querySelectorAll(`.${s.tout}`);
		touts.forEach(tout => unobserveScroll(tout));

		const filtersContainer = document.querySelector(`.${s.filtersContainer}`);
		if (this.isLibrary && filtersContainer) {
			unobserveScroll(filtersContainer);
		}

		// remove query params
		window.history.replaceState(null, null, window.location.pathname);
	}

	componentDidUpdate() {
		this.checkTitleHeight();
		if (!this.isLibrary) {
			return;
		}

		const dynamicData = this.props.store?.dynamicData?.eventLibrary;
		if (dynamicData && !this.state.dynamicDataUpdated) {
			this.events = dynamicData.projects || [];
			this.addExtraDynamicFilters();
			this.toutStacks = [
				{
					key: 'dynamic-touts',
					touts: this.events.reduce((acc, project, index) => {
						acc = {
							...acc,
							[slugify(project.title)]: {
								src: project.asset,
								title: project.title,
								description: project.description,
								filters: project.filterTags.map(tag => tag.filter).join(', '),
								order: index + 1,
								path: project.link || '',
							}
						};
						return acc;
					}, {})
				}
			];

			this.setState({ dynamicDataUpdated: true });
		}
	}

	async loadCustomData() {
		if (this.props?.id === 'utdProgramsAndInitiatives') {
			const dynamicData = await getDynamicData('utd');

			let utdTouts = dynamicData?.utdProgramsAndInitiatives?.touts;
			this.toutStacks = [{ touts: utdTouts }];
			if (utdTouts.length) {
				utdTouts = utdTouts.filter(tout => tout.enabled !== false);
				this.dynamicTouts = utdTouts;
				// this.setState({});
			}
		}
		if (this.props?.id === 'belowTheLineProduction') {
			const dynamicData = await getDynamicData('below-the-line');
			const dynamicTouts = dynamicData?.belowTheLineProduction?.touts;
			const dynamicHeading = dynamicData?.belowTheLineProduction?.heading;
			const dynamicSeeMore = dynamicData?.belowTheLineProduction?.seeMore;

			if (dynamicTouts?.length) {
				const alphaSorted = [...dynamicTouts].sort((a, b) =>
					a.title.localeCompare(b.title)
				);
				this.dynamicTouts = alphaSorted;
				this.toutStacks = [{ touts: this.dynamicTouts }];
				this.dynamicFilterCats = this.buildDynamicFilterCategories(dynamicTouts);
				if (this.dynamicFilterCats?.length) {
					this.filterCategories = this.dynamicFilterCats.map(cat => ({
						name: cat.category,
						filters: cat.filters.split(',').map(f => f.trim())
					}));
				}
			}

			if (dynamicHeading) {
				this.dynamicHeading = dynamicHeading;
			}
			if (dynamicSeeMore) {
				this.dynamicSeeMore = dynamicSeeMore;
			}

			this.setState({});
		}
		if (this.props?.id === 'events') {
			const dynamicData = await getDynamicData('events');
			if (dynamicData.pageEnabled === false) {
				navigateInternally('homeMIU');
				return;
			}
			const eventTouts = dynamicData?.projects;
			const eventHeading = dynamicData?.title;

			if (eventTouts?.length) {
				this.dynamicTouts = eventTouts.map((project, index) => ({
					title: project.title,
					description: project.description,
					src: project.src,
					alt: project.alt || project.title,
					filters: project.filterTags?.map(tag => tag.filter)?.join(', ') || '',
					order: index + 1,
					path: project.link || ''
				}));

				this.toutStacks = [{ key: 'Library', touts: this.dynamicTouts }];
				this.dynamicFilterCats = this.buildDynamicFilterCategories(eventTouts);

				if (this.dynamicFilterCats?.length) {
					this.filterCategories = this.dynamicFilterCats.map(cat => ({
						name: cat.category,
						filters: cat.filters.split(',').map(f => f.trim())
					}));
				}
			}

			if (eventHeading) {
				this.dynamicHeading = {
					title: eventHeading,
					filtersEnabled: dynamicData.filtersEnabled,
					description: dynamicData.description
				};
			}

			this.setState({});
		}

	}

	buildDynamicFilterCategories(touts) {
		const map = {};

		for (const tout of touts) {
			if (tout.filters) {
				if (!map['Country']) map['Country'] = new Set();
				map['Country'].add(tout.filters.trim());
			}
			if (Array.isArray(tout.filterTags)) {
				for (const tag of tout.filterTags) {
					const cat = tag.category || 'Custom';
					const val = tag.filter?.trim();

					if (!val) continue;

					if (!map[cat]) map[cat] = new Set();
					map[cat].add(val);
				}
			}
		}
		return Object.entries(map).map(([category, set]) => ({
			category,
			filters: [...set].join(', ')
		}));
	}

	addExtraDynamicFilters() {
		this.events.forEach((project) => {
			project.filterTags.forEach((tag) => {
				const existingCategory = this.filterCategories.find((cat) => cat.name === tag.category);
				if (existingCategory && !existingCategory.filters.includes(tag.filter)) {
					existingCategory.filters.push(tag.filter);
					if (existingCategory.name === 'Year') { //here
						existingCategory.filters.sort((a, b) => +b - +a);
					}
				}
			});
		});

	}

	checkTitleHeight() {
		const newIsMultilineMap = {};

		Object.entries(this.titleRefs).forEach(([key, el]) => {
			if (!el) return;
			const lineHeight = parseFloat(getComputedStyle(el).lineHeight);
			const height = el.offsetHeight;
			newIsMultilineMap[key] = height > lineHeight + 2;
		});

		if (JSON.stringify(newIsMultilineMap) !== JSON.stringify(this.state.isTitleMultilineMap)) {
			// console.log('Multiline state:', newIsMultilineMap);
			this.setState({ isTitleMultilineMap: newIsMultilineMap });
		}
	}

	toggleFiltersMenu() {
		this.setState({ filtersMenuOpen: !this.state.filtersMenuOpen });
		if (this.state.filtersMenuOpen) {
			//console.log('TOGGLE FILTERS OPEN');
			Store.emit('CUSTOM_EVENT', {
				category: this.props.id,
				action: 'more-filters-click',
			});
		}
	}

	onFilterBtnClick({ catIndex, filter, isActive }) {
		Store.emit('VERTICAL_TOUT_FILTER_CLICK', ({
			catIndex,
			filter,
			pageId: this.props.id,
			ALL: this.props?.appData?.copy?.baseCopy?.$FILTERS_ALL
		}));
		if (!isActive) {
			const label = filter === this.props?.appData?.copy?.baseCopy?.$FILTERS_ALL ? `${this.filterCategories[catIndex].name} - ${filter}` : filter;
			//console.log('CUSTOM EVENT, CATEGORY: ', this.props.id, 'ACTION: filter-select, LABEL: ', this.filterCategories[catIndex].name + '_' + filter );
			Store.emit('CUSTOM_EVENT', {
				category: this.props.id,
				action: 'filter-select',
				label: this.filterCategories[catIndex].name + '_' + filter
			});
		}
	}

	triggerButtonClick(data) {
		const { path, title, button, sameWindow } = data;
		let action = this.props.id.includes('utd') ? 'tout-click' : 'tile-click';
		Store.emit('CUSTOM_EVENT', {
			category: this.props.id,
			action: action,
			label: title
		});

		if (this.props.id === 'belowTheLineProduction') {
			const dynamicTout = this.dynamicTouts?.find(t => t.title === data.title) || {};

			const baseSource = this.props.appData?.options?.cmsManaged ? dynamicTout : data;

			this.textOverlay = {
				...baseSource,
				...dynamicTout.textContent,
				filters: dynamicTout.filterTags?.map(tag => tag.filter).join(', ') || data.filters
			};

			if (this.textOverlay) {
				this.toggleTextOverlay(true);
			}
			return;
		}


		if (path.startsWith('http')) {
			let link = document.createElement('a');
			link.href = path;
			link.target = sameWindow ? '_self' : '_blank';
			link.style.display = 'none';
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		} else if (path.startsWith('@')) {
			return Store.emit('OPEN_RESERVED_VARIABLE_LINK', path);
		} else if (path.startsWith('tickets/?id=')) {
			const movieId = path.replace('tickets/?id=', '').trim();
			this.openShowtimesAndFilterForMovieId(movieId);
		} else if (isVideosPage(path)) {
			return Store.emit('OPEN_VIDEO_OVERLAY', path);
		} else if (path === 'boltShowtimes') {
			return Store.emit('SHOWTIMES_SHOW', true);
		} else if (path === 'boltHomeEnt') {
			return Store.emit('HOMEENT_SHOW', true);
		} else {
			const pathIsSection = accessNested(this.props, `appData.pages.${path}.section`, false);
			if (pathIsSection) {
				return Store.emit('CHANGE_ACTIVE_SECTION', path);
			} else {
				return Store.emit('CLOSE_AND_NAVIGATE', path);
			}
		}
	}

	onClearAllFilters() {
		Store.emit('VERTICAL_TOUT_CLEAR_FILTERS', ({
			pageId: this.props.id,
			ALL: this.props?.appData?.copy?.baseCopy?.$FILTERS_ALL
		}));
	}

	getExtraFiltersCount() {
		const selectedFilters = this.props?.store?.toutVertical?.[this.props.id]?.selectedFilters || [];
		const extraFilterCategories = selectedFilters.slice(NUM_STICKY_FILTER_CATEGORIES);
		let count = 0;
		extraFilterCategories.forEach((filterArray) => {
			if (filterArray.includes(this.props?.appData?.copy?.baseCopy?.$FILTERS_ALL)) {
				return;
			}
			count += filterArray.length;
		});
		return count;
	}

	sortTouts(touts) {
		const copy = this.props?.appData?.copy?.baseCopy || {};
		const ALL = copy.$FILTERS_ALL;
		const sortedTouts = sortObjectByOrder(touts);
		const selectedFilters = this.props?.store?.toutVertical?.[this.props.id]?.selectedFilters || [];
		const selectedFiltersFlat = selectedFilters.reduce((acc, curr) => {
			if (!curr.includes(ALL)) {
				acc.push(...curr);
			}
			return acc;
		}, []);

		let count = 0;
		const filteredTouts = sortedTouts.filter((tout) => {
			const filterItems = [
				...(tout.filters?.split(',').map(f => f.trim()) || []),
				...(tout.filterTags?.map(tag => tag.filter.trim()) || [])
			];

			let shouldIncludeTout = false;
			if (count < this.state.libraryToutLength) {
				if (selectedFiltersFlat.length === 0) {
					shouldIncludeTout = true;
				} else {
					selectedFiltersFlat.forEach((filter) => {
						if (filterItems.includes(filter) || filterItems.includes(ALL)) {
							shouldIncludeTout = true;
						}
					});
				}

				if (shouldIncludeTout) count++;
			}
			return shouldIncludeTout;
		});
		return filteredTouts;
	}

	getFilterLabel({ filter, category }) {
		const copy = this.props?.appData?.copy?.baseCopy || {};
		// if (category.name === 'Region' && filter === copy.$FILTERS_ALL) { // here
		// 	return 'GLOBAL';
		// }
		return filter;
	}

	renderNoResults() {
		const copy = this.props?.appData?.copy?.baseCopy || {};
		return (
			<div class={s.noResults}>
				<p>{copy.$FILTERS_NO_RESULTS}</p>
			</div>
		);
	}

	renderToutStack(data) {

		if (!data.touts) {
			return;
		}
		const sortedTouts = this.sortTouts(data.touts);

		if (!sortedTouts.length) {
			return this.renderNoResults();
		}
		const base = super.renderToutStack(data);
		return base;
	}

	triggerLoadMoreButtonClick() {
		this.setState(prevState => {
			return {
				libraryToutLength: prevState.libraryToutLength + 4
			};
		});
	}

	isToutEmpty(tout) {
		const { title, tag, description, src, filters, path } = tout || {};
		const hasFilters = filters && filters.split(',').some(f => f.trim());
		return !title && !tag && !description && !src && !hasFilters && !path;
	}

	renderTout(data, index) {
		if (this.isLibrary) {
			if (!data?.src || data.src.trim() === '') return;
			const { title, description, src, alt, filters = '' } = data;
			const filterItems = filters.split(',').filter(e => e).map(item => item.trim());
			const isVideo = src?.endsWith('.mp4') || src?.endsWith('.webm');
			const dynamicData = this.dynamicHeading || {};

			let toutClickable = this.isEventsLibrary || (dynamicData.overlaysEnabled || this.props?.data?.overlaysEnabled);
			return (
				<div class={s.tout} key={`${this.props.id}-${data.title}`}>
					<button onClick={() => toutClickable && this.triggerButtonClick(data)} class={!toutClickable && s.disabled}>
						{!!src && isVideo ? (
							<video class={joinClasses(s.video, s.image)} src={src} autoplay loop muted playsinline />
						) : (
							<div>
								<img crossOrigin="anonymous" class={s.image} src={src} alt={alt} />
							</div>
						)}
						<div class={s.content}>
							{title && this.isEventsLibrary && (
								<h2 ref={this.setTitleRef(data.title)} class={joinClasses(s.toutTitle, '3')}>
									<HTML tag="span" markdown content={title} />
								</h2>
							)}
							{!!filterItems.length && (
								<div class={s.filters} key="filters">
									{filterItems.map(filter => <span class={joinClasses(s.filter, 'small')}>{filter}</span>)}
								</div>
							)}
							{description && (
								<HTML
									tag="h3"
									class={joinClasses(s.toutDescription, s.showGradient, 'large', this.state.isTitleMultilineMap[data.title] ? s.descriptionShort : s.descriptionLong)}
									content={description}
									markdown
									key="description"
								/>
							)}
							{this.renderButton(data)}
						</div>
					</button>
				</div>
			);

		} else {
			const isDynamic = this.props.appData?.options?.cmsManaged && this.dynamicTouts?.length;
			const toutData = isDynamic ? this.dynamicTouts[index] : data;
			if (!toutData || this.isToutEmpty(toutData)) return null;

			const { title, tag, description, src, alt, filters = '' } = toutData;
			const filterItems = filters.split(',').filter(e => e).map(item => item.trim());
			const { activeFilter } = this.state;
			if ((filterItems.indexOf(activeFilter) <= -1) && (activeFilter !== 'all')) {
				return;
			}
			const isVideo = src?.endsWith('.mp4') || src?.endsWith('.webm');

			return (
				<div class={s.tout}>
					{!!src && isVideo ? (
						<video class={joinClasses(s.video, s.image)} src={src} autoplay loop muted playsinline />
					) : (
						<img crossOrigin="anonymous" class={s.image} src={src} alt={alt} />
					)}
					<div class={s.content}>
						{title && <HTML tag="h2" markdown content={title} class={joinClasses(s.toutTitle, 'h2')} />}
						{tag && <HTML markdown content={tag} class={joinClasses(s.toutTag, 'xlargeB')} />}
						{!!filterItems.length && (
							<div class={s.filters} key="filters">
								{filterItems.map(filter => <span class={joinClasses(s.filter, 'small')}>{filter}</span>)}
							</div>
						)}
						{description && (
							<HTML
								tag="h3"
								class={joinClasses(s.toutDescription, s.showGradient, 'large')}
								content={description}
								markdown
								key="description"
							/>
						)}
						{toutData.path && this.renderButton(toutData)}
					</div>
				</div>
			);
		}

	}

	renderButton(data) {
		const button = data?.button;
		if (!button) return;
		const content = button.includes('$') ? getCopy(button) : button;

		return (
			<button
				class={joinClasses(s.button, 'mediumB', data.disableButton && s.disabled)}
				onClick={() => this.triggerButtonClick(data)}
				data-text={button}
			>
				{content}
			</button>
		);
	}

	renderFilterCategories({ containerClass, filterCategoriesArray, mapKeyPrefix }) {
		const copy = this.props?.appData?.copy?.baseCopy || {};
		const selectedFilters = this.props?.store?.toutVertical?.[this.props.id]?.selectedFilters || [];
		return (
			<div class={containerClass}>
				{filterCategoriesArray.map((category, catIndex) => {
					return (
						<div class={s.filterCategory} key={`${mapKeyPrefix}-${category.name}`}>
							<p class={s.filterCatName}>{category.name}</p>
							<div class={s.filterBtns}>
								{[copy.$FILTERS_ALL, ...category.filters].map((filter, index) => {
									const activeFilters = selectedFilters[catIndex] || [];
									const isActive = activeFilters.includes(filter);
									return (
										<button
											class={joinClasses(s.filterBtn, isActive && s.active)}
											key={`${mapKeyPrefix}-btn-${filter}`}
											onClick={() => this.onFilterBtnClick({ catIndex, filter, isActive })}
											style={{ animationDelay: `${0.2 + (0.1 * index)}s` }}
										>
											{this.getFilterLabel({ filter, category })}
										</button>
									);
								})}
							</div>
						</div>
					);
				})}
			</div>
		);
	}

	renderDisplayedFilters() {
		const isDesktopWidth = this.props?.store?.client?.isDesktopWidth;

		return (
			<div class={s.filtersContainer}>
				{this.renderFilterCategories({
					containerClass: s.displayedFilters,
					filterCategoriesArray: this.filterCategories.slice(0, NUM_STICKY_FILTER_CATEGORIES),
					mapKeyPrefix: 'displayed-filters'
				})}
				{isDesktopWidth && this.renderMoreFiltersBtn()}
			</div>
		);

	}

	renderMoreFiltersBtn() {
		const copy = this.props?.appData?.copy?.baseCopy || {};
		const extraFiltersCount = this.getExtraFiltersCount();

		return (
			<button class={s.moreFiltersBtn} onClick={this.toggleFiltersMenu}>
				<div class={joinClasses(s.moreFiltersCounter, extraFiltersCount < 1 && s.hide)}>
					<span>{extraFiltersCount}</span>
				</div>
				<Filters class={s.filtersIcon} />
				<span>{this.isbelowTheLineProduction ? copy.$MORE_COUNTRIES : copy.$MORE_FILTERS}</span>
			</button>
		);
	}

	renderExpandedFiltersMenu() {
		const copy = this.props?.appData?.copy?.baseCopy || {};
		const { filtersMenuOpen } = this.state;

		return (
			<div class={joinClasses(s.filtersMenuContainer, filtersMenuOpen && s.open)}>
				<button class={s.filtersCloseBtn} onClick={this.toggleFiltersMenu}>
					<Close class={s.closeIcon} />
				</button>
				<div class={s.filtersExpandedMenu}>
					<h3 class={s.filtersMenuTitle}>{copy.$FILTERS_TITLE}</h3>
					<button class={s.resetFilters} onClick={this.onClearAllFilters}>{copy.$FILTERS_CLEAR_ALL}</button>
					{this.renderFilterCategories({
						containerClass: s.expandedFilterCategories,
						filterCategoriesArray: this.filterCategories,
						mapKeyPrefix: 'menu-filters'
					})}
				</div>
				<div class={s.viewProjectsBtnContainer}>
					<button class={s.viewProjectsBtn} onClick={this.toggleFiltersMenu}>
						{this.isbelowTheLineProduction ? copy.$VIEW_MOVIES : copy.$VIEW_PROJECTS}
					</button>
				</div>
			</div>
		);
	}

	renderFadeOverlay() {
		const { filtersMenuOpen } = this.state;
		return (
			<div class={joinClasses(s.fadeOverlay, filtersMenuOpen && s.show)} onClick={this.toggleFiltersMenu} />
		);
	}

	renderTextOverlay(textOverlay) {
		if (!textOverlay) return;
		const show = this.state.textOverlayOpen;

		return (
			<HubTextOverlay
				content={textOverlay}
				isFilm
				show={show}
				closeOverlay={() => this.toggleTextOverlay(false)}
			/>
		);
	}

	toggleTextOverlay(open) {
		this.setState({ textOverlayOpen: open });
		Store.emit('CAROUSEL_TEXT_OVERLAY_SHOW', open ? this.props.carouselId : null);
	}

	get getTouts() {
		if (this.props.appData?.options?.cmsManaged && this.dynamicTouts?.length) {
			return this.dynamicTouts;
		}
		const pageData = this.props.appData.pages?.[this.props.id]?.data;
		return Object.values(pageData.Library?.touts || {});

	}

	render(props, state) {
		const base = super.render(props, state);

		if (this.isLibrary) {
			if (this.filterCategories?.length === 0) {
				return null;
			}
			const isDesktopWidth = props?.store?.client?.isDesktopWidth;
			const touts = this.getTouts;

			const copy = this.props?.appData?.copy?.baseCopy || {};
			const seeMoreButtonCopy = this.dynamicSeeMore || copy.$SEE_MORE_BUTTON_COPY || 'See more';

			base.children.push(
				<button
					class={joinClasses(s.button, this.state.libraryToutLength >= touts.length && s.disableButton)}
					data-text={seeMoreButtonCopy}
					onClick={() => this.triggerLoadMoreButtonClick()}
				>
					{seeMoreButtonCopy}
				</button>
			);

			const dynamicData = this.dynamicHeading || {};

			let filtersEnabled = dynamicData?.filtersEnabled !== undefined
				? dynamicData.filtersEnabled
				: this.props?.data?.filtersEnabled;
			if (filtersEnabled) {
				const displayedFilters = this.renderDisplayedFilters();
				!isDesktopWidth && base.children.unshift(this.renderMoreFiltersBtn());
				base.children.unshift(displayedFilters);
			}

			const description = dynamicData.description || this.pageData.description;
			if (description) {
				base.children.unshift(
					<HTML tag="h3" class={s.description} content={description} markdown />
				);
			}

			const title = dynamicData.title || this.pageData.title; //this.pageTitle || this.props?.appData?.copy?.baseCopy?.$PROJECT_LIBRARY_TITLE || 'TITLE';
			if (title) {
				base.children.unshift(
					<h2 class={s.title}>{title}</h2>
				);
			}
			const fadeOverlay = this.renderFadeOverlay();
			base.children.push(fadeOverlay);
			if (filtersEnabled) {
				const expandedFiltersMenu = this.renderExpandedFiltersMenu();
				base.children.push(expandedFiltersMenu);
			}
			const textOverlay = this.renderTextOverlay(this.textOverlay);
			{this.isbelowTheLineProduction && base.children.push(textOverlay);}
		}
		return base;
	}
}
